import { createContext } from 'react';

const selectedDistributionFilterItems = [];

export const DistributionFilterContext = createContext(
  selectedDistributionFilterItems
);
